module.exports = {
    item: "brf-value list-group-item-text"
};


/** WEBPACK FOOTER **
 ** ./~/subschema/src/styles/List-style.js
 **/